<template>
  <div class="swiper-box">
    <div class="swiper-contain">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(spuImg, spuIndex) in spuImgs"
          :key="spuIndex"
        >
          <img :src="spuImg" alt="banner" />
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/css/swiper.min.css';
export default {
  name: 'swiper',
  props: {
    spuImgs: {
      type: [Array],
      default: []
    }
  },
  data() {
    return {
      spuImgArr: [],
      spuImgLength: 0,
      activeClass: '.swiper-contain', //滑动模块名称,
      pagination: '.swiper-pagination'
    };
  },
  watch: {
    spuImgs: {
      handler: function (newVal) {
        this.spuImgArr = newVal;
        console.log('this.spuImgArr', newVal);
        this.spuImgLength = this.spuImgArr.length;
      },
      immediate: true
    }
  },
  methods: {},
  mounted() {
    const that = this;
    new Swiper(this.activeClass, {
      autoplay: true, //自动播放
      loop: true, //循环播放
      delay: 3000, //每张图间隔三秒
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, //修改swiper的父元素时，自动初始化swiper
      //分页器
      pagination: {
        el: this.pagination,
        type: 'custom',
        renderCustom: function (swiper, current, total) {
          let totalVal = that.spuImgLength;
          return current + ' / ' + totalVal;
        }
      }
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
// @import '@/assets/css/color.scss';
.swiper-box {
  height: 100%;
  background-color: #f8f8f8;
  font-size: 24px;
  color: #06112a;
  height: 750px;
  overflow: hidden;
}
.swiper-slide img {
  display: block;
  width: 100%;
  /*height: 750px;*/
}
.swiper-contain {
  position: relative;
  text-align: right;
}
.swiper-pagination {
  width: 90px !important;
  height: 48px !important;
  background: rgba(139, 103, 103, 0.3);
  color: #fff;
  position: absolute;
  left: auto !important;
  right: 30px !important;
  bottom: 24px !important;
  border-radius: 24px;
  line-height: 48px;
  font-size: 26px;
  font-weight: 500;
  // text-align:right;
  // padding-right:32px;
}
</style>



// WEBPACK FOOTER //
// src/components/swiper.vue